import { render, staticRenderFns } from "./WorkFlowControlBox.vue?vue&type=template&id=4fcf8d79&scoped=true"
import script from "./WorkFlowControlBox.vue?vue&type=script&lang=js"
export * from "./WorkFlowControlBox.vue?vue&type=script&lang=js"
import style0 from "./WorkFlowControlBox.vue?vue&type=style&index=0&id=4fcf8d79&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fcf8d79",
  null
  
)

export default component.exports